import { GOLDEN_TOWER, BLACK_HOLE } from 'utils/constants';

const DeathWave = ({ unlocked, showAll }) => (
  <div className='weapon'>
    {!showAll && <div className='title'>You should pick Death Wave</div>}
    {showAll && <div className='title'>Death Wave</div>}
    {(showAll || !unlocked[GOLDEN_TOWER]) && (
      <div className='info'>Keep looking for Golden Tower.</div>
    )}
    {(showAll || !unlocked[BLACK_HOLE]) && (
      <div className='info'>Keep looking for Black Hole.</div>
    )}
    <div className='info'>
      Death Wave is the worst, most overrated Ultimaye Weapon in the game, and
      should be your absolute last choice. You can get most of the benefit out
      of using the perk version, which you can easily force every run. Syncing
      it is not nearly as important as GT and BH, and so you should not pursue
      it at their expense. Health is not the way to go in this game after your
      very early stages, and Death Wave misleads people into building further
      into it than they should, rather than transitioning towards a hybrid or
      damage build, and you can also get the health bonus off of the perk. Cells
      are also overrated, the cell lab takes considerable labtime and takes a
      while for its ROI to pay back off, you should wait to pursue the higher
      levels of the cell lab until sometime around when you can maintain 3x
      boosts on everything without it, as being able to push your damage and
      farm higher tiers will do more for your cell count than the lab will,
      while also helping your tournament and stone progress.
    </div>
  </div>
);

export default DeathWave;
